import { HelsenorgeHttpError, getCorrelationIdFromResponse } from './hn-proxy-service';
import resources from './resources/HN.CoreFrontend.NPM.Packages.FrameworkUtils.nb-NO.json';
/**
 * Returnerer en query string basert på parametrene som sendes inn
 *
 * @param params objekt med parametrene
 * @param options includePrefix - dersom satt til true vil query string starte med spørsmålstegn (?)
 */
export const createQueryString = (params, options) => {
    if (!params) {
        return '';
    }
    const { includePrefix = true } = options || {};
    const prefix = includePrefix ? '?' : '';
    if (params instanceof URLSearchParams) {
        const queryString = params.toString();
        return queryString ? `${prefix}${queryString}` : '';
    }
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach(item => {
                if (typeof item !== 'undefined') {
                    searchParams.append(key, String(item));
                }
            });
        }
        else {
            if (typeof value !== 'undefined') {
                searchParams.append(key, String(value));
            }
        }
    });
    const queryString = searchParams.toString();
    return queryString ? `${prefix}${queryString}` : '';
};
/**
 * Oppretter nytt Header-objekt med Accept og Content-type
 * @param type application/json er default
 * @param method HTTP-metoden som skal brukes (valgfritt). Dersom method er 'GET', vil ikke 'Content-Type' settes.
 */
export const createBaseHeaders = (type = 'application/json', method) => {
    if (method?.toLowerCase() === 'get') {
        return new Headers({
            Accept: type,
        });
    }
    return new Headers({
        Accept: type,
        'Content-Type': type,
    });
};
/**
 * Sjekker status på en Response og håndterer JSON-parsing og feilmapping.
 *
 * @param response Response objektet fra HTTP request
 * @param mapError Mapper responsen om til en Error hvis det har skjedd en feil
 * @throws {Error} Feilobjektet returnert fra mapError, eller HelsenorgeHttpError ved manglende/feil content-type
 */
export const checkResponseStatus = (response, mapError) => {
    const correlationId = getCorrelationIdFromResponse(response);
    if ([204, 205, 304].includes(response.status)) {
        return Promise.resolve(null);
    }
    return response.text().then(body => {
        if (body.trim() === '' && response.ok) {
            return null;
        }
        const contentType = response.headers.get('content-type');
        if (!contentType?.includes('application/json')) {
            throw new HelsenorgeHttpError(response.status, resources.technical_error_message, correlationId);
        }
        if (body.trim() === '') {
            throw mapError(response, correlationId, undefined);
        }
        let parsedBody;
        try {
            parsedBody = JSON.parse(body);
        }
        catch {
            throw mapError(response, correlationId, undefined);
        }
        if (response.ok) {
            return parsedBody;
        }
        throw mapError(response, correlationId, parsedBody);
    });
};
/**
 * Sjekker status på en Response og returnerer en Promise avhengig av status
 * @param response Response objektet fra HTTP request
 * @throws {HelsenorgeHttpError} Dersom APIet svarer med en feil som ikke er i standard-format
 */
export const checkStatus = (response) => {
    const mapError = (res, correlationId, body) => new HelsenorgeHttpError(res.status, resources.technical_error_message, correlationId, body);
    return checkResponseStatus(response, mapError);
};
